import { nanoid } from 'nanoid';
import { assignProperties } from '../../../../schemaUtils';
import { POLL_RATING_STARS as QuestionType } from '../../../../types/webview.generated';
import { config } from './RatingStarsPoll.config';

type Answer = QuestionType['data']['answers'][number];

export function generateQuestion(answers: Answer[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        answers,
        text: '',
        maximumValue: 5,
        requiresAnswer: true,
        logicRules: [],
        goToRules: [],
        preset: 'rating',
        justifyContent: 'center',
      },
      overrides,
    ),
  };
}

export function generateAnswer(overrides: Partial<Answer> = {}): Answer {
  return {
    id: nanoid(10),
    exclusiveAnswer: true,
    text: '',
    ...overrides,
  };
}
